module.exports = __webpack_public_path__ + "img/2000-box.907cb26e.png";